module.exports = __webpack_public_path__ + "img/add_customer.ee1c9bd0.jpg";